'use client';
import React__default from 'react';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { Combobox, comboboxPropTypes } from './combobox.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

/**
 * @subcomponent Combobox
 */ const ComboboxWithFloatingLabel = renderWithRef('Combobox', comboboxPropTypes, (props, ref)=>{
    const { className, children } = props;
    const classes = new Set([
        'swan-combobox-with-floating-label',
        'swan-input-with-floating-label'
    ]);
    if (className) classes.add(className);
    return /*#__PURE__*/ React__default.createElement(FloatingLabelContextProvider, null, /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: Combobox,
        forwardedRef: ref,
        props: props,
        classNames: classes
    }, children));
});

export { ComboboxWithFloatingLabel };
